jQuery(document).ready(function() {
    jQuery('.link-cust').each(function() {
        var element = jQuery(this);
        var text = element.text().toLowerCase(); // Convert entire text to lowercase
        text = text.charAt(0).toUpperCase() + text.slice(1); // Capitalize the first letter
        element.text(text);
    });
});
